import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../redux/reducers/rootReducer';

/**
 * Custom hook that synchronizes Redux language state with i18next
 * Use this hook at the App level to handle language changes globally
 */
export const useLanguageSync = () => {
  const { i18n } = useTranslation();
  const language = useSelector((state: RootState) => state.language);

  useEffect(() => {
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  return language;
};